import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgMongoDb = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-mongo-db';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M3.24 11.92v8.24H6v-1.48H4.76V5.16H6V3.68H3.24zM18 4.42v.74h1.24v13.52H18v1.48h2.76V3.68H18zm-6.812.35c-.812.805-1.265 1.341-1.763 2.086-1.156 1.73-1.866 3.819-1.863 5.484.002 1.41.404 2.694 1.229 3.924a8.3 8.3 0 0 0 2.099 2.147l.35.247V20.4h1.52v-1.679l.33-.166c1.965-.987 3.237-3.296 3.338-6.058.037-1.022-.064-1.838-.333-2.677-.438-1.371-1.365-2.917-2.608-4.353C13.148 5.075 12.055 4 11.996 4c-.017 0-.381.346-.808.77m1.18 1.7c1.304 1.513 2.174 3.073 2.459 4.41.093.432.105 2.054.019 2.5-.269 1.405-.736 2.384-1.501 3.146-.184.184-.392.367-.46.406l-.125.073V12.12h-1.519l-.011 2.327-.01 2.327-.251-.232a6.35 6.35 0 0 1-1.63-2.518c-.205-.61-.272-1.114-.249-1.86.043-1.425.583-2.951 1.572-4.444.434-.655 1.237-1.64 1.337-1.64.018 0 .184.175.369.39"
    })
  }));
});
export default SvgMongoDb;